import { TourProvider } from '@reactour/tour';
import { useContext, useEffect, useLayoutEffect, useRef } from 'react';
import { ThemeProvider } from 'react-jss';
import { ReactNotifications } from 'react-notifications-component';
import { Route, Routes, useLocation } from 'react-router-dom';
import { ToastProvider } from 'react-toast-notifications';
import { useFullscreen } from 'react-use';
import ThemeContext from '../contexts/themeContext';

import COLORS from '../common/data/enumColors';
import { Toast, ToastContainer } from '../components/bootstrap/Toasts';
import { getOS } from '../helpers/helpers';
import useDarkMode from '../hooks/useDarkMode';
import Aside from '../layout/Aside/Aside';
import Portal from '../layout/Portal/Portal';
import Wrapper from '../layout/Wrapper/Wrapper';
import { demoPages, layoutMenu } from '../menu';
import TrackingVehicle from '../pages/tracking/Tracking';
// import Login from '../pages/presentation/auth/Login';
// import PublicRoute from '../protectedRoutes/PublicRoute';
import steps, { styles } from '../steps';
import VehicleShippingAgreementModal from '../components/VehicleShippingAgreementModal';

const App = () => {
	getOS();

	/**
	 * Dark Mode
	 */
	const { themeStatus, darkModeStatus } = useDarkMode();
	const theme = {
		theme: themeStatus,
		primary: COLORS.PRIMARY.code,
		secondary: COLORS.SECONDARY.code,
		success: COLORS.SUCCESS.code,
		info: COLORS.INFO.code,
		warning: COLORS.WARNING.code,
		danger: COLORS.DANGER.code,
		dark: COLORS.DARK.code,
		light: COLORS.LIGHT.code,
	};
	useEffect(() => {
		if (darkModeStatus) {
			document.documentElement.setAttribute('theme', 'dark');
		}
		return () => {
			document.documentElement.removeAttribute('theme');
		};
	}, [darkModeStatus]);

	/**
	 * Full Screen
	 */
	// @ts-ignore
	const { fullScreenStatus, setFullScreenStatus } = useContext(ThemeContext);
	const ref = useRef(null);
	useFullscreen(ref, fullScreenStatus, {
		onClose: () => setFullScreenStatus(false),
	});

	/**
	 * Modern Design
	 */
	useLayoutEffect(() => {
		if (process.env.REACT_APP_MODERN_DESGIN === 'true') {
			document.body.classList.add('modern-design');
		} else {
			document.body.classList.remove('modern-design');
		}
	});

	//	Add paths to the array that you don't want to be "Aside".
	const withOutAsidePages = [demoPages.login.path, demoPages.signUp.path, layoutMenu.blank.path];

	const location = useLocation();
	const isTrackingPage = location.pathname.startsWith('/vehicle/track-vehicle');

	return (
		<>
			{isTrackingPage ? (
				<Routes>
					<Route path='/vehicle/track-vehicle/' element={<TrackingVehicle />} />
				</Routes>
			) : (
				<ThemeProvider theme={theme}>
					<ToastProvider components={{ ToastContainer, Toast }}>
						<TourProvider
							steps={steps}
							styles={styles}
							showNavigation={false}
							showBadge={false}>
							<div
								ref={ref}
								className='app'
								style={{
									backgroundColor: fullScreenStatus
										? 'var(--bs-body-bg)'
										: undefined,
									zIndex: fullScreenStatus ? 1 : undefined,
									overflow: fullScreenStatus ? 'scroll' : undefined,
								}}>
								<Routes>
									{withOutAsidePages.map((path) => (
										<Route key={path} path={path} />
									))}
									{/* <Route
								path={demoPages.login.path}
								element={
									<PublicRoute>
										<Login />
									</PublicRoute>
								}
							/> */}
									{/* <Route
								path='*'
								element={
									<PrivateRoute>
										{' '}
										<Aside />{' '}
									</PrivateRoute>
								}
							/> */}
									<Route path='*' element={<Aside />} />
									<Route
										path='/vehicle/track-vehicle/:id'
										element={<TrackingVehicle />}></Route>
								</Routes>
								<Wrapper />
							</div>
							<Routes></Routes>
							<Portal id='portal-notification'>
								<ReactNotifications />
							</Portal>
						</TourProvider>
					</ToastProvider>
					<VehicleShippingAgreementModal />
				</ThemeProvider>
			)}
		</>
	);
};

export default App;
